import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class RecordExamineAPIClass extends BasicsClass {

    public apiUrls: any = new Map([
        ['getReportTableList', {
            url: '/admin/im/reportList',
            name: 'list',
            label: '举报列表'
        }],
        ['handleReport', {
            url: '/admin/im/handleReport',
            name: 'handle-report',
            label: '处理举报'
        }]

    ])
    // 举报列表
    public getRecordExamineTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const start_date = Util.handleStartTimeAndEndTime(params.time).startTime;
        const end_date = Util.handleStartTimeAndEndTime(params.time).endTime;

        params = {
            ...(params || {}),
            start_date: start_date,
            end_date: end_date
        }

        const apiUrls = this.apiUrls

        const url = apiUrls.get('getReportTableList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // 处理举报
    public handleReport(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('handleReport').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }
}
